import { TransferPricingDocumentationRequestHelper } from './transfer-pricing-documentation-request-helper';
import type {
  IStartTransferPricingDocumentationWorkflowParams,
  IStartTransferPricingDocumentationWorkflowResponse,
  TTransferPricingDocumentationMutationResult,
} from './types';

const FALLBACK_ERROR_MESSAGE =
  'Could not start the workflow. Please try again.';

export const startTransferPricingDocumentationWorkflow = (
  documentationId: string,
  params: IStartTransferPricingDocumentationWorkflowParams,
  token?: string
): Promise<
  TTransferPricingDocumentationMutationResult<IStartTransferPricingDocumentationWorkflowResponse>
> =>
  TransferPricingDocumentationRequestHelper.send({
    path: `${TransferPricingDocumentationRequestHelper.recordPath(documentationId)}/workflow`,
    method: 'POST',
    body: { ...params },
    isExpectedBody:
      TransferPricingDocumentationRequestHelper.isStartWorkflowResponse,
    fallbackErrorMessage: FALLBACK_ERROR_MESSAGE,
    token,
  });
